import { Fragment, useCallback, useEffect, useState } from "react"
import { Table } from "common/Table/Table"
import { exportToCSV } from "utils/funcs"

import UserService from "services/user.service"

const service = new UserService();

export const BoardStates = () => {

  const columns = [
    {key: "leader_id", dbColName: "leader_id", title: "leader id"},
    {key: "leader_name", dbColName: "leader_name", title: "leader name"},
    {key: "total_candidates", dbColName: "total_candidates", title: "total candidates"},
    {key: "Career Portal", dbColName: "source_breakdown", title: "Career Portal", render: source => source["Career Portal"]},
    {key: "Cheyenne Thatcher", dbColName: "source_breakdown", title: "Cheyenne Thatcher", render: source => source["Cheyenne Thatcher"]},
    {key: "Google", dbColName: "source_breakdown", title: "Google", render: source => source["Google"]},
    {key: "Indeed", dbColName: "source_breakdown", title: "Indeed", render: source =>  source["Indeed"]},
    {key: "IndeedSponsored", dbColName: "source_breakdown", title: "Indeed Sponsored", render: source => source["IndeedSponsored"]},
    {key: "Monster", dbColName: "source_breakdown", title: "Monster", render: source => source["Monster"]},
    {key: "Website", dbColName: "source_breakdown", title: "Website", render: source => source["Website"]},
    {key: "careerjet", dbColName: "source_breakdown", title: "Career Jet", render: source => source["careerjet"]},
    {key: "flexjobs", dbColName: "source_breakdown", title: "Flex jobs", render: source => source["flexjobs"]},
    {key: "google_jobs_apply", dbColName: "source_breakdown", title: "Google Jobs Apply", render: source => source["google_jobs_apply"]},
    {key: "ziprecruit", dbColName: "source_breakdown", title: "zip recruit", render: source => source["ziprecruit"]},
    {key: "preseason_fp_plus", dbColName: "preseason_fp_plus", title: "preseason fp plus"},
    {key: "preseason_fp", dbColName: "preseason_fp", title: "preseason fp"},
    {key: "preseason_upgrades", dbColName: "preseason_upgrades", title: "preseason upgrades"},
    {key: "preseason_rws", dbColName: "preseason_rws", title: "preseason rws"},
    {key: "production_fp_plus", dbColName: "production_fp_plus", title: "production fp plus"},
    {key: "production_fp", dbColName: "production_fp", title: "production fp"},
    {key: "production_upgrades", dbColName: "production_upgrades", title: "production upgrades"},
    {key: "production_rws", dbColName: "production_rws", title: "production rws"},
  ]

  const [data, setData] = useState([])
  const [totalItems, setTotalItems] = useState(0)
  const [loading, setLoading] = useState(false)
  const [pagination, setPagination] = useState({
    pageNumber: 1,
    pageSize: 100,
  })

  const fetchData = useCallback(() => {
    setLoading(true)
    service
      .boardStates()
      .then((resp) => {
        if (resp.data.success) {
          setData(resp.data.data)
          setTotalItems(resp.data.data.length)
        }
      })
      .catch((error) => {
        console.log(error)
      })
      .finally(() => {
        setLoading(false)
      })
  }, [])

  useEffect(() => {
    fetchData()
  }, [fetchData])

  const handleExport = () => {
    exportToCSV(data, "states")
  }

  return (
    <Fragment>
      <div className="flex flex-col mb-4">
        <h1 className="page-title">
          Board States
        </h1>
        <p className="page-subtitle">View all </p>
      </div>
      <Table
        data={data}
        pagination={pagination}
        setPagination={setPagination}
        setData={setData}
        loadingData={loading}
        handleExport={handleExport}
        totalItems={totalItems}
        columns={columns}
      />
    </Fragment>
  )
}
